import { MultiValue } from 'react-select';
import { SelectOptionType } from '@/components/element/Form/SelectOptionType';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

type MultiSelectProps = {
  options: SelectOptionType[];
  setOptions: Dispatch<SetStateAction<SelectOptionType[]>>;
  selectedLabels?: string[];
  onChange: (d: MultiValue<SelectOptionType>) => void;
};

export const SelectMultiCreatable = ({ options, setOptions, selectedLabels, onChange }: MultiSelectProps) => {
  const [values, setValues] = useState<SelectOptionType[]>([]);

  const _onChange = (d: MultiValue<SelectOptionType>) => {
    const _values = d.map((_d) => _d);
    setValues(_values);

    // 新規登録されたデータをoptionsに追加
    const _options = options.filter((d) => d.__isNew__ == null);
    for (const v of _values) {
      if (v.__isNew__) {
        _options.push(v);
      }
    }
    setOptions(_options);
    onChange(d);
  };

  useEffect(() => {
    if (options && selectedLabels) {
      setValues(options.filter((option) => selectedLabels.includes(option.label)));
    }
  }, [options, selectedLabels]);

  return (
    <CreatableSelect
      theme={(theme) => ({
        ...theme,
        borderRadius: 3,
        colors: {
          ...theme.colors,
          primary25: '#e9aede',
          primary: '#e9aede',
        },
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderRadius: '0.5rem',
        }),
      }}
      isMulti={true}
      options={options}
      onChange={_onChange}
      value={values}
    />
  );
};
